import { getNextSibling } from "../utils/dom";
import { clamp } from "../utils/utils";

export default class MultiSelect extends HTMLDivElement {

    connectedCallback() {

        this.addEventListener("hide.bs.dropdown", this.handleClose);
        this.addEventListener("shown.bs.dropdown", this.handleShown);
        
    }

    disconnectedCallback() {

        this.removeEventListener("hide.bs.dropdown", this.handleClose);
        this.removeEventListener("shown.bs.dropdown", this.handleShown);

    }

    handleClose = (e) => {

        const selected = this.checkboxes.filter(cb => cb.checked);
        const selectedCount = selected != null ? selected.length : 0;

        if (selectedCount === 0) {
            this.button.innerText = this.defaultText;
        }
        else if (selectedCount === 1) {
            this.button.innerText = this.getLabelTextForCheckbox(selected[0]);
        }
        else {
            this.button.innerText = `${selectedCount} valda`;
        }

    }

    handleShown = (e) => {
        const menu = this.menu;
        const space = window.innerHeight - this.getClientRects()[0].top - this.offsetHeight - Math.max(window.innerHeight * .05, 16);
        menu.style.maxHeight = clamp(space, window.innerHeight * .25, window.innerHeight * .5) + "px";
        menu.style.overflowY = "auto";
        menu.style.minWidth = "100%";

    }

    getLabelTextForCheckbox(checkbox) {
        return getNextSibling(checkbox, "label")?.textContent.trim();
    }

    get defaultText() {
        return this.dataset.defaultText || "Alla";
    }

    get button() {
        return this.querySelector("[data-bs-toggle=dropdown]");
    }

    get menu() {
        return this.querySelector(".dropdown-menu");
    }

    get checkboxes() {
        return Array.from(this.querySelectorAll("input[type=checkbox]"));
    }
}

customElements.define('multi-select', MultiSelect, { extends: 'div' });